module.exports = __webpack_public_path__ + "img/bb_g3_ears-01.cb4fa90c.svg";